import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Модальные окна встраиваются в конец <body> с помощью порталов реакта
 *
 * Модальное окно у нас состоит из 3 оберток
 * на все классы есть свои модификаторы
 * modal-layout  --  основной класс ( расположение, напр. -mobile-halfsize )
 * modal-main  --  размер окна (-m и т.д.)
 * modal-content  --  контент (доп классы для фона и др. оформления, напр. bg-dragonfly4)
 */

export default class Modal extends React.Component {
  static defaultProps = {
    layoutClass: '',
    mainClass: '',
    contentClass: '',
    modalCloseButton: true,
  };

  static propTypes = {
    layoutClass: PropTypes.string,
    mainClass: PropTypes.string,
    contentClass: PropTypes.string,
    modalCloseButton: PropTypes.bool,
    children: PropTypes.any.isRequired,
  };

  componentWillMount() {
    this.root = document.createElement('div');
    document.body.appendChild(this.root);
  }

  componentWillUnmount() {
    document.body.removeChild(this.root);
  }

  render() {
    const {
      layoutClass, mainClass, contentClass, modalCloseButton,
    } = this.props;

    return ReactDOM.createPortal(
      <div className={classNames('modal-layout', layoutClass)}>
        <div className={classNames('modal-main', mainClass)}>
          <div className={classNames('modal-content', 'clearfix', contentClass)}>
            {this.props.children}
          </div>

          {modalCloseButton ? <div className="modal-close">Закрыть всплывающее окно</div> : ''}
        </div>
      </div>,

      this.root,
    );
  }
}
